/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Up to 20 dice at once, each with 4, 6, 8, 10, 12 or 20 sides.`)
};

const es_dice_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hasta 20 dados a la vez, cada uno con 4, 6, 8, 10, 12 o 20 caras.`)
};

const de_dice_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bis zu 20 Würfel gleichzeitig, jeweils mit 4, 6, 8, 10, 12 oder 20 Seiten.`)
};

const nl_dice_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tot 20 dobbelstenen tegelijk, elk met 4, 6, 8, 10, 12 of 20 zijden.`)
};

const fr_dice_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jusqu'à 20 dés à la fois, chacun avec 4, 6, 8, 10, 12 ou 20 faces.`)
};

const it_dice_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fino a 20 dadi alla volta, ciascuno con 4, 6, 8, 10, 12 o 20 facce.`)
};

const pt_br2_dice_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até 20 dados de uma vez, cada um com 4, 6, 8, 10, 12 ou 20 lados.`)
};

const pt_dice_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Até 20 dados de uma vez, cada um com 4, 6, 8, 10, 12 ou 20 faces.`)
};

const ja_dice_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大20個まで同時に振れます。それぞれ4、6、8、10、12、20面から選べます。`)
};

const zh_dice_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次最多可掷 20 个骰子，每个可选 4、6、8、10、12 或 20 面。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_faq_a2", locale)
	if (locale === "en") return en_dice_faq_a2(inputs)
	if (locale === "es") return es_dice_faq_a2(inputs)
	if (locale === "de") return de_dice_faq_a2(inputs)
	if (locale === "nl") return nl_dice_faq_a2(inputs)
	if (locale === "fr") return fr_dice_faq_a2(inputs)
	if (locale === "it") return it_dice_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_dice_faq_a2(inputs)
	if (locale === "pt") return pt_dice_faq_a2(inputs)
	if (locale === "ja") return ja_dice_faq_a2(inputs)
	return zh_dice_faq_a2(inputs)
};